import { render, staticRenderFns } from "./AddAnalysisEligibilityBox.vue?vue&type=template&id=21df3af7&scoped=true"
import script from "./AddAnalysisEligibilityBox.vue?vue&type=script&lang=js"
export * from "./AddAnalysisEligibilityBox.vue?vue&type=script&lang=js"
import style0 from "./AddAnalysisEligibilityBox.vue?vue&type=style&index=0&id=21df3af7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21df3af7",
  null
  
)

export default component.exports